import React, { useEffect, useState } from "react";
import axios from "axios";
import TopNavbar from "./ui/countdown/topNavbar/topNavbar";
import MiddleHeader from "./ui/headers/middleHeader";
import Searchbar from "./includes/Searchbar";
import Footer from "./ui/footer/footer";
import Searchfield from "./ui/searchfield/Searchfield";

function Blog() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchArticles = async () => {
      try {
        const response = await axios.get("/blog");
        setArticles(response.data);
      } catch (error) {
        console.error("Error fetching blog articles:", error);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div className="page-wrapper">
      <header className="header">
        <TopNavbar />
        <MiddleHeader />
        <Searchbar />
        <Searchfield />
      </header>

      <main className="main">
        <div className="page-header">
          <div className="container" style={{ marginBottom: "1rem" }}>
            <h1
              className="page-title mb-0 text-5xl font-bold"
              style={{ marginTop: "1rem" }}
            >
              BPPYRO Blog
            </h1>
          </div>
        </div>

        <div className="page-content mb-10 pb-2">
          <div className="container">
            <div className="row gutter-lg">
              <div className="main-content">
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "1.5rem",
                    justifyContent: "space-between",
                  }}
                >
                  {articles.filter(a => a.type === 'blog').filter((a) => a.type === "blog")
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((article) => (
                    <article
                      key={article.id}
                      className="post post-grid-type overlay-zoom mb-6 fashion"
                      style={{
                        flex: "1 1 calc(25% - 1.5rem)", // 4 per row with gap
                        maxWidth: "calc(25% - 1.5rem)",
                        boxSizing: "border-box",
                      }}
                    >
                      <figure className="post-media br-sm">
                        <a href={`/blog/${article.slug}`}>
                          <img
                            src={article.cover_image || "default-image.jpg"}
                            alt={article.title}
                            style={{
                              width: "100%",
                              height: "auto",
                              maxHeight: "250px",
                              objectFit: "cover",
                            }}
                          />
                        </a>
                      </figure>
                      <div className="post-details">
                        <h4 className="post-title">
                          <a href={`/blog/${article.slug}`}>
                            {article.title}
                          </a>
                        </h4>
                        <div className="post-content">
                          <a href={`/blog/${article.slug}`}>
                            <p style={{ color: "#999" }}>
                              {article.excerpt || "Keine Vorschau verfügbar..."}
                            </p>
                          </a>
                          <a href={`/blog/${article.slug}`}>
                            <span className="btn btn-link btn-primary">
                              (mehr erfahren)
                            </span>
                          </a>
                        </div>
                        <div className="post-meta">
                          <span className="post-date">
                            {new Date(article.created_at).toLocaleDateString(
                              "de-DE"
                            )}
                          </span>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Blog;
